export default __webpack_public_path__ + "static/media/user.acc0453c.svg";